import {
  evaluateTemplateValue,
  dataLocationToPath,
} from "@ea-lab/reactive-json";

/**
 * Generic "collect one field across a collection into an array slot".
 *
 * Why a custom reaction (config-first escape hatch) : mapping a collection to an
 * array of one field's values (e.g. every row's `nid`) is NOT expressible in
 * reactive-json YAML — there is no map/pluck over a data collection, and
 * `addData`/`setData` cannot iterate. This fills exactly that gap for a
 * "select all on page" master checkbox : set `path` = [row.field, …] over the
 * collection at `from`. Pair it with a plain `setData … []` for "deselect all".
 *
 * YAML usage :
 *   - what: collectField
 *     on: change
 *     from: ~~.esResult.contents   # the collection
 *     field: nid                    # the field to pluck from each item
 *     path: ~~.selection            # array slot to write
 *
 * Items that are non-objects or whose field is null/undefined are skipped.
 * Registered in [App.jsx](../../../App.jsx) under `customPlugins.reaction.collectField`.
 */
export const collectFieldReaction = (props) => {
  const { args, globalDataContext, templateContext } = props;
  if (!args) return;

  const gdc = globalDataContext.getRootContext
    ? globalDataContext.getRootContext()
    : globalDataContext;

  const resolve = (v) =>
    evaluateTemplateValue({ valueToEvaluate: v, globalDataContext: gdc, templateContext });

  const collection = resolve(args.from);
  const field = resolve(args.field);
  if (!field) return;

  const path =
    typeof args.path === "string"
      ? dataLocationToPath({
          dataLocation: args.path,
          currentPath: templateContext?.templatePath,
          globalDataContext: gdc,
          templateContext,
        })
      : null;
  if (!path) return;

  const list = Array.isArray(collection) ? collection : [];
  const values = list
    .map((it) => (it && typeof it === "object" ? it[field] : undefined))
    .filter((v) => v !== null && v !== undefined);

  gdc.updateData(values, path);
};
